// The fonts a site text can be set in: Google Sans and the pixel fonts (tools/build-pixel-fonts.js; their faces are in m3.css and
// only download when used). Same keys as FONTS in apps/portal/site-settings.js, which validates them on the server.
//   window.SiteFonts.css(key)  -> a font-family value, or undefined for '' / unknown (= keep the font the site setting gives)
//   <FontPicker label value onChange(key) allowDefault />  a small select with each font's name drawn in that font; '' = site default
(function () {
  const CHOICES = [
    { key: 'google-sans', label: 'Google Sans', css: "'Google Sans', 'Google Sans Text', Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
    { key: 'pixel', label: 'Whimsical Pixel', css: "'Whimsical Pixel', 'Google Sans', monospace", step: 10 },
    { key: 'pixel-small', label: 'Whimsical Pixel Small', css: "'Whimsical Pixel Small', 'Google Sans', monospace", step: 8 },
    { key: 'round', label: 'Whimsical Round', css: "'Whimsical Round', 'Google Sans', monospace", step: 10 },
    { key: 'round-small', label: 'Whimsical Round Small', css: "'Whimsical Round Small', 'Google Sans', monospace", step: 8 }
  ];
  const css = key => (CHOICES.find(c => c.key === key) || {}).css;

  function FontPicker({ label = 'Font', value = '', onChange, allowDefault = true, sx }) {
    const { Select } = window.Components;
    const options = [
      ...(allowDefault ? [{ value: '', label: 'Site default' }] : []),
      ...CHOICES.map(c => ({ value: c.key, label: c.label }))
    ];
    return <Select size="small" label={label} value={value || ''} options={options} onChange={e => onChange(e.target.value)} sx={{ minWidth: 220, ...sx }} />;
  }

  window.SiteFonts = { CHOICES, css };
  window.Components = window.Components || {};
  window.Components.FontPicker = FontPicker;
})();
